import React, { useEffect } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import ButtonSubmit from '../../common/ButtonSubmit'
import { selectQuery } from '../../../redux/selectors/routerSelectors'
import { publishViewedInviteDialog } from '../../../util/events/teamsEventPublishers'
import { selectUserTeam } from '../../../redux/selectors/userTeamSelectors'
import {
  acceptInviteStart,
  declineInviteStart,
  loadInviterTeamNameStart,
} from '../../../redux/modules/userTeam'

const DialogAcceptDecline = () => {
  const { teamInviteCode } = useSelector(selectQuery)
  const userTeam = useSelector(selectUserTeam)
  const inviterTeamName = useSelector(state => state.userTeam.inviterTeamName)
  const isAcceptingInvite = useSelector(state => state.userTeam.isAcceptingInvite)
  const isDecliningInvite = useSelector(state => state.userTeam.isDecliningInvite)
  const dispatch = useDispatch()

  const handleAccept = () => {
    dispatch(acceptInviteStart())
  }

  const handleDecline = () => {
    dispatch(declineInviteStart())
  }

  useEffect(() => {
    if (teamInviteCode || (!teamInviteCode && userTeam?.invitation)) {
      publishViewedInviteDialog(teamInviteCode)
    }
  }, [teamInviteCode, userTeam])

  useEffect(() => {
    if (teamInviteCode) {
      dispatch(loadInviterTeamNameStart(teamInviteCode))
    }
  }, [teamInviteCode, dispatch])

  const open =
    ((inviterTeamName && Boolean(teamInviteCode)) || Boolean(userTeam?.invitation)) &&
    !userTeam?.team
  const teamName = userTeam?.invitation?.teamName || inviterTeamName
  return (
    <Dialog open={open}>
      <DialogTitle>Join the {teamName} team</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You&apos;ve been invited to join the Foodsby team <b>{teamName}</b>. Accept to start
          enjoying all of the benefits, such as discounted price for unlimited delivery and free
          delivery on group orders!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonSubmit
          submitting={isDecliningInvite}
          disabled={isAcceptingInvite}
          onClick={handleDecline}
        >
          Decline
        </ButtonSubmit>
        <ButtonSubmit
          submitting={isAcceptingInvite}
          disabled={isDecliningInvite}
          variant="contained"
          color="primary"
          onClick={handleAccept}
        >
          Accept
        </ButtonSubmit>
      </DialogActions>
    </Dialog>
  )
}

export default DialogAcceptDecline
